import favoriteSvg from "@assets/images/FavoritedPinkSvg.svg";
import favoriteLOutlineSvg from "@assets/images/FavoriteOutlineSvg.svg";
import { ReactComponent as HotbarIcon } from "@assets/images/Hotbar.svg";
import DefaultIyugaLogo from "@assets/images/iyuga.jpg";
import { ReactComponent as BusinessBoxIcon } from "@assets/images/segmentEditor/Busniess.svg";
import { isEmpty } from "lodash";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import { Clone, Description, Edit, List, Share } from "../../assets/icons";
import FeedbackIcon from "../../assets/icons/Social/Feedback";
import HiddenWheelIcon from "../../assets/images/hidden-wheel.svg";
import { Button, TextView } from "../../components";
import AccessKeyEnterModal from "../../components/AccessKeyEnterModal";
import AuthorInfo from "../../components/AuthorInfo";
import { BroadCastModal } from "../../components/BroadcastModal";
import Loader from "../../components/CustomLoader";
import CustomSwitch from "../../components/CustomSwitch";
import GeneralDialog from "../../components/GeneralDialogBox";
import InfoHeader from "../../components/MobileView/InfoHeader";
import SegmentsList from "../../components/MobileView/SegmentsList";
import NewHotbar from "../../components/NewHotbar/NewHotbar";
import PreviewCarousel from "../../components/NewHotbar/PreviewCarousel";
import BusinessBoxBuilder from "../../components/SegmentBuilder/Main/BusinessBoxBuilder";
import SegmentView from "../../components/SegmentView";
import SocialFoxFeedbackForm from "../../components/SocialFoxFeedbackForm";
import WheelComponent from "../../components/WheelComponent";
import BackdropSpinner from "../../components/WheelGallery/WheelListing/ListComponents/BackdropSpinner";
import WheelHeader from "../../components/WheelHeader";
import WheelInfo from "../../components/WheelInfo";
import { FEATURES } from "../../constants/features";
import { useWheelSegments } from "../../contexts/wheelSegments";
import { useIfUserEligible } from "../../hooks/useIfUserEligible";
import useScreenSize from "../../hooks/useScreenSize";
import {
  closeDialogPopup,
  openDialogPopup,
} from "../../redux/reducers/dialogPopup";
import { openGeneralDialogModal } from "../../redux/reducers/generalDialog";
import { openNonAuthenticatedModal } from "../../redux/reducers/nonAuthenticatedModal";
import { setSegmentItems } from "../../redux/reducers/newhotbar";
import { setBusinessBoxWheel } from "../../redux/reducers/segmentBuilder";
import {
  canCloneWheel,
  getWheelDetails,
  likeUnlikeWheel,
  takeWheelScreenshot,
} from "../../services/api";
import API from "../../services/request";
import { API_PATH } from "../../utils/config";
import {
  useCloneWheel,
  useFavoriteWheel,
  useUnlockWheelV2,
} from "../../services/mutations";
import ToastMessage from "../../sharedcomponents/Toast";
import { ASSETS, TOAST_TYPE } from "../../utils/config";
import {
  convertSnakeToCamel,
  extractAudiosFromCraftString,
  extractDocumentsFromCraftString,
  extractImagesFromCraftString,
  extractUrlsFromNodes,
  extractVideosFromCraftString,
  getLoggedInUser,
  isUserLoggedIn,
  fetchImageAsBase64,
  transformedText,
} from "../../utils/helpers";
import Editor from "../SegmentBuilder/Editor";
import ShareModal from "../WheelView/ShareModal";
import MobileView from "./MobileView";
import * as Styled from "./styles";
import ShareInviteModal from "../../components/ShareInviteModal";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
// Screenshot functionality moved to backend Lambda
// import { getWheelUploadPath, handleFileUpload } from "../../utils/fileUpload";
// import { useScreenshot } from "use-react-screenshot";
// import ScreenshotModal from "./ScreenshotModal";
import { useGetUserProfileById } from "../../services/queries";
import NonAuthenticatedModal from "../../components/NonAuthenticatedModal";
import { closeNonAuthenticatedModal } from "../../redux/reducers/nonAuthenticatedModal";
import { closeGeneralDialogModal } from "../../redux/reducers/generalDialog";

export default function ViewWheel() {
  const { isMobilePortrait, isMobileLandscape, isTablet } = useScreenSize();
  const [isHiddenWheel, setIsHiddenWheel] = useState(false);
  const nav = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [loading, setLoading] = useState(true);
  const [wheelData, setWheelData] = useState({});
  const [wheelSegments, setWheelSegments] = useState([]);
  const [wallpaperSettings, setWallpaperSettings] = useState({});

  // Show info section after loading is complete
  useEffect(() => {
    if (!loading) {
      setShowInfo(true);
    }
  }, [loading]);
  const [showLabels, setShowLabels] = useState(
    isMobileLandscape ? false : true
  );
  const [showInfo, setShowInfo] = useState(false);
  const [openShare, setOpenShare] = useState(false);
  const [isLiked, setIsLiked] = useState(false);
  const [segmentListOpen, setSegmentListOpen] = useState(false);
  const cloneWheel = useCloneWheel();
  const [inviteShareModalVisible, setInviteShareModalVisible] = useState(false);
  const [openFeedbackModal, setOpenFeedbackModal] = useState(false);
  const [openPasswordModal, setOpenPasswordModal] = useState(false);
  const [newHotbarVisible, setNewHotbarVisible] = useState(false);
  const [businessBoxVisible, setBusinessBoxVisible] = useState(false);
  const [base64Wallpaper, setBase64Wallpaper] = useState(null);
  const [centerImageBase64, setCenterImageBase64] = useState(null);

  const [profile, setProfile] = useState(null);
  const [isFollowing, setIsFollowing] = useState(false);
  const [followLoading, setFollowLoading] = useState(false);
  const [followerCount, setFollowerCount] = useState(0);

  const galleryBusinessBox = useSelector(
    (state) => state.userProfile?.userProfile?.business_box
  );

  const {
    data: profileData,
    isLoading: profileDataLoading,
    isFetching: profileDataFetching,
    refetch: refetchProfile,
  } = useGetUserProfileById(wheelData?.user_profile?.user_id);

  const {
    selectedType,
    selectedItem,
    isPreviewOpen,
    selectedSegment,
    segments,
    selectedSegmentId,
  } = useSelector((state) => state?.hotbar);

  const [showCloneUpdateModal, setshowCloneUpdateModal] = useState(false);
  const [showIsLiveToStaticModal, setshowIsLiveToStaticModal] = useState(false);
  const unlockWheel = useUnlockWheelV2();
  const { wheelId } = useParams();

  const { addSegments, addWheelData } = useWheelSegments();
  const favoriteWheel = useFavoriteWheel();

  const isFavorite = wheelData?.is_favourite;

  const selectedArc = wheelSegments.find((seg) => seg.selected);

  const { bgWallpaper, segmentBgColor, currentBg } = wallpaperSettings;
  const wallpaperTransparency = 100; // Hardcoded to 100

  const userData = {
    id: uuidv4(),
    url: centerImageBase64,
    isBase64: true,
  };

  const { isEligible } = useIfUserEligible(FEATURES.BUSINESS_BOX);

  function sortSegmentsByPosition(segments) {
    return segments.sort((a, b) => a.position - b.position);
  }

  const clonedWheelData = useMemo(
    () =>
      sortSegmentsByPosition(
        wheelSegments?.map((segment) => ({
          ...segment,
          ...segment?.settings,
        }))
      ),
    [wheelSegments]
  );

  const showModalToUser = (user_id) => {
    // setTimeout(() => {
    //   setInviteShareModalVisible(true);
    // }, 45000);
  };

  useEffect(() => {
    if (wheelId) {
      const params = new URLSearchParams(location.search);
      const key = params.get("key"); // Get the key from URL

      // Store the previous path in location state if we came from gallery
      if (
        location.state?.from === undefined &&
        location.pathname.includes("/gallery/")
      ) {
        nav(location.pathname, {
          state: { from: location.pathname },
          replace: true,
        });
      }

      // If key exists in URL, treat it as email_key
      if (key) {
        getWheelData(wheelId, { emailKey: key });
      } else {
        getWheelData(wheelId, {});
      }
    }
  }, [wheelId, location.pathname]);

  // fetch follow status once when wheelData is available
  useEffect(() => {
    const fetchFollowStatus = async () => {
      const userId = wheelData?.user_profile?.user_id;
      const loggedInUserId = getLoggedInUser()?.id;

      // Don't fetch if it's the user's own profile or no user ID
      if (!userId || userId === loggedInUserId) return;

      try {
        const res = await API.get(API_PATH.FOLLOW_STATUS(userId));
        const d = res?.data || {};
        setIsFollowing(Boolean(d.is_following));
        setFollowerCount(d.follower_count ?? followerCount);
      } catch (err) {
        // ignore
      }
    };

    if (wheelData?.user_profile?.user_id) {
      fetchFollowStatus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wheelData?.user_profile?.user_id]);

  const getWheelData = async (id, { emailKey = null, anonymousKey = null }) => {
    setLoading(true);
    localStorage.removeItem("referralData");
    try {
      const queryParams = emailKey
        ? `?email_key=${emailKey}`
        : anonymousKey
        ? `?anonymous_key=${anonymousKey}`
        : "";
      const res = await getWheelDetails(id, queryParams);

      if (res?.data?.data) {
        const response = res.data.data;
        const { wheel_segments, ...restResponse } = response;

        if (
          restResponse.visibility === 3 &&
          restResponse.user !== getLoggedInUser()?.id
        ) {
          setIsHiddenWheel(true);
          return;
        }

        // Process wheel segments
        const modifiedSegmentData = wheel_segments.map((s) => {
          const { nodes, ...rest } = s;

          return {
            ...rest,
            category: 1, // Replace with actual category id
            settings: convertSnakeToCamel(s.settings),
            nodes: typeof nodes === "string" ? JSON.parse(nodes) : nodes,
          };
        });

        addWheelData(restResponse);
        addSegments(modifiedSegmentData);
        // Extract user profile data
        const { first_name, last_name, referral_code, is_in_referral_program } =
          response?.wheel_referrer;

        const referralData = JSON.stringify({
          first_name,
          last_name,
          referral_code,
        });

        if (!isEmpty(response.business_box)) {
          dispatch(setBusinessBoxWheel(response.business_box));
        }
        if (isEmpty(response.business_box) && !isEmpty(galleryBusinessBox)) {
          dispatch(setBusinessBoxWheel(galleryBusinessBox));
        }
        if (isEmpty(response.business_box) && isEmpty(galleryBusinessBox)) {
          dispatch(setBusinessBoxWheel(null));
        }

        if (response?.live_to_static) {
          setshowIsLiveToStaticModal(true);
        } else {
          setshowCloneUpdateModal(response?.changes_update);
        }

        // Set referral data in both storages
        if (is_in_referral_program) {
          sessionStorage.setItem("referralData", referralData);
          localStorage.setItem("referralData", referralData);
        } else {
          sessionStorage.removeItem("referralData");
          localStorage.removeItem("referralData");
        }

        // sessionStorage.setItem("referralData", referralData);
        // localStorage.setItem("referralData", referralData);

        // Show modal if applicable
        showModalToUser(response?.user_profile?.user_id || -1);

        // Update state with processed data
        setWallpaperSettings(convertSnakeToCamel(response.wallpaper_settings));
        setWheelData(response);
        setIsLiked(response.is_favourite);
        setWheelSegments(modifiedSegmentData);
        const processedSegments = extractItemsFromSegments(modifiedSegmentData);
        dispatch(setSegmentItems(processedSegments));
        setOpenPasswordModal(false);
      }
    } catch (error) {
      console.log({ error: error?.response?.data?.data });
      if (error?.response?.data?.data?.is_locked) {
        setOpenPasswordModal(true);
      } else {
        toast.error(error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (profileData) {
      setProfile(profileData?.data);
      // if profile contains follower counts, use it as initial value
      setFollowerCount(profileData?.data?.followers ?? 0);
    }
  }, [profileData]);

  const extractItemsFromSegments = (segments) => {
    return segments.map((segment) => {
      const { nodes, id } = segment;
      const { title, color } = segment?.settings;

      let parsedNodes = nodes;
      if (wheelData?.is_cloned || wheelData?.is_copied_from_clone) {
        parsedNodes = nodes;
      } else {
        try {
          parsedNodes = JSON.parse(nodes);
        } catch (error) {
          console.error("Error parsing nodes JSON:", error);
        }
      }

      // Extract items
      const images = extractImagesFromCraftString(parsedNodes);
      const videos = extractVideosFromCraftString(parsedNodes);
      const audios = extractAudiosFromCraftString(parsedNodes);
      const documents = extractDocumentsFromCraftString(parsedNodes);
      const links = extractUrlsFromNodes(parsedNodes);

      return {
        title,
        items: {
          images,
          videos,
          audios,
          documents,
          links,
        },
        segmentColor: color,
        segmentId: id,
      };
    });
  };

  const onSegmentClose = () => {
    if (selectedArc) {
      const idToRemove = selectedArc.id;
      const updatedChartData = wheelSegments?.map((data) => {
        if (data?.id === idToRemove) {
          data.selected = false;
        }
        return data;
      });
      setWheelSegments(updatedChartData);
    }
  };

  const onSegmentOpen = () => {
    onSegmentClose();

    const updatedChartData = wheelSegments?.map((data) => {
      if (data?.id === selectedSegmentId) {
        data.selected = true;
      }
      return data;
    });
    setWheelSegments(updatedChartData);
  };

  const navigateToSignup = () => {
    const { is_in_referral_program, referral_code } = wheelData?.wheel_referrer;

    if (is_in_referral_program)
      window.location.href = `/signup/${referral_code}`;
    else window.location.href = `/signup`;
  };

  const openRestrictionPopup = () => {
    dispatch(
      openDialogPopup({
        isOpen: true,
        title: "Upgrade to Clone More Wheels!",
        primaryButtonTitle: "Upgrade today!",
        secondaryButtonTitle: "Cancel",
        text: "You've reached your limit of 5 Clones. Upgrade your plan to unlock unlimited Clones and enjoy all of the additional features!",
        secondaryButtonOnClick: () => dispatch(closeDialogPopup()),
        primaryButtonOnClick: () => {
          dispatch(closeDialogPopup());
          nav("/settings?option=subscriptions");
        },
      })
    );
  };

  const handleCloneWheel = async () => {
    if (isUserLoggedIn()) {
      if (wheelData?.already_cloned) {
        showClonePopup();
      } else {
        dispatch(
          openGeneralDialogModal({
            isOpen: true,
            title1: "Are you sure you want to clone this wheel?",
            primaryButtonTitle: "Absolutely!",
            imageSrc: ASSETS.DialogImg,
            primaryButtonOnClick: async () => {
              try {
                const response = await canCloneWheel();
                if (response.status === 200) {
                  cloneWheel.mutate(
                    { wheelId: wheelData?.id },
                    {
                      onSuccess: (res) => {
                        toast.success("Wheel has been cloned.");
                      },
                      onError: (err) => console.log(err),
                    }
                  );
                }
                if (response.status === 403) {
                  openRestrictionPopup();
                }
              } catch (err) {
                if (err.status === 403) {
                  openRestrictionPopup();
                }
              }
            },
            secondaryButtonTitle: "Go back",
            secondaryButtonOnClick: () => {},
          })
        );
      }
    } else {
      dispatch(
        openGeneralDialogModal({
          isOpen: true,
          title1: "Want to clone this wheel? Get an iYuga account!",
          primaryButtonTitle: "Login",
          imageSrc: ASSETS.DialogImg,
          primaryButtonOnClick: () => {
            nav("/login");
            // setInviteShareModalVisible(true);
          },
          secondaryButtonTitle: "Create an account",
          secondaryButtonOnClick: navigateToSignup,
        })
      );
    }
  };

  const handleFavoriteWheel = async () => {
    if (isUserLoggedIn()) {
      favoriteWheel.mutate(wheelData?.id, {
        onSuccess: async (res) => {
          const params = new URLSearchParams(location.search);
          const key = params.get("key"); // Get the key from URL

          if (key) {
            await getWheelData(wheelId, { emailKey: key });
          } else {
            await getWheelData(wheelId, {});
          }
        },
        onError: (err) => {
          console.log(err);
          toast.error("Something went wrong while favoriting this wheel");
        },
      });
    } else {
      dispatch(
        openGeneralDialogModal({
          isOpen: true,
          title1: "Want to favorite this wheel? Get an iYuga account!",
          primaryButtonTitle: "Login",
          imageSrc: ASSETS.DialogImg,
          primaryButtonOnClick: () => {
            nav("/login");
            // setInviteShareModalVisible(true);
          },
          secondaryButtonTitle: "Create an account",
          secondaryButtonOnClick: navigateToSignup,
        })
      );
    }
  };

  const handleSetChartData = useCallback(
    (newChartData) => {
      const updatedData = newChartData.map((segment) => ({ ...segment }));
      setWheelSegments(updatedData);
      addSegments(updatedData);
    },
    [setWheelSegments, addSegments]
  );

  const handleSwitch = () => setShowLabels(!showLabels);

  const handleLikeUnlike = async () => {
    if (getLoggedInUser()?.id) {
      try {
        const { data: response } = await likeUnlikeWheel(wheelData?.id);
        if (response.success) {
          setIsLiked(response.data.is_favourite);
        }
      } catch (err) {
        console.log(err);
      }
    } else {
      dispatch(
        openGeneralDialogModal({
          isOpen: true,
          title1: "If you want to like this wheel, make an iYuga account!",
          primaryButtonTitle: "Login",
          imageSrc: ASSETS.DialogImg,
          primaryButtonOnClick: () => {
            // nav("/login");
            setInviteShareModalVisible(true);
          },
          secondaryButtonTitle: "Create an account",
          secondaryButtonOnClick: navigateToSignup,
        })
      );
    }
  };

  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    const convertCenterImage = async () => {
      let urlToConvert = wheelData?.wheel_center_media?.url;
      if (!urlToConvert) {
        urlToConvert = DefaultIyugaLogo;
      }
      if (urlToConvert && !urlToConvert.startsWith("data:image")) {
        try {
          const base64 = await fetchImageAsBase64(urlToConvert);
          setCenterImageBase64(base64);
        } catch (error) {
          setCenterImageBase64(urlToConvert); // fallback to original if conversion fails
        }
      } else {
        setCenterImageBase64(urlToConvert);
      }
    };
    convertCenterImage();
  }, [wheelData?.wheel_center_media?.url]);
  
  const is_editable =
    wheelData?.is_cloned && wheelData?.is_live ? false : wheelData?.is_editable;
  const isLoggedInUserAuthor =
    getLoggedInUser()?.id === wheelData?.wheel_author?.user_id;
  const isMyWheel = wheelData?.user_profile?.user_id === getLoggedInUser()?.id;
  const isWheelClonable = wheelData?.is_clonable;

  const rightContent = isMobileLandscape
    ? []
    : [
        // {
        //   title: "Quick Search",
        //   icon: <Search />,
        //   onClick: () => {},
        // },
        {
          title: "Feedback Form",
          icon: <FeedbackIcon />,
          tooltip: "Give Feedback",
          onClick: () => {
            setOpenFeedbackModal(true);
          },
        },
        //if i have cloned a live wheel ? should i show any edit icon
        // ---> wheel cloned, wheel author not me, wheel is live or wheel is locked
        //can we clone a locked wheel?
        // if not, then we should hide the clone option on locked wheels or locked wheel should automatically become not clonable in the settings builder
        is_editable
          ? {
              title: "Edit",
              tooltip: "Edit",
              icon: (
                <a
                  href={`/builder/${wheelId}`}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Edit />
                </a>
              ),
            }
          : null,
        !isHiddenWheel && !isLoggedInUserAuthor && !isMyWheel //someone else's wheel
          ? {
              title: isWheelClonable ? "Clone Wheel" : "Cloning Disabled",
              icon: isWheelClonable ? (
                <Clone></Clone>
              ) : (
                <img
                  alt="Cloning Disabled"
                  height={24}
                  width={24}
                  src={ASSETS.CloningDisabled}
                ></img>
              ),

              tooltip: isWheelClonable
                ? "Clone this wheel"
                : "Cloning Disabled",
              onClick: () => {
                isWheelClonable && handleCloneWheel();
              },
            }
          : null,
        !isHiddenWheel &&
        getLoggedInUser()?.id !== wheelData?.user_profile?.user_id
          ? {
              title: isFavorite ? "Unfavorite Wheel" : "Favorite Wheel",
              icon: isFavorite ? (
                <img
                  src={favoriteSvg}
                  className="img-fluid"
                  alt="Edit"
                  width="20"
                  height="20"
                />
              ) : (
                <img
                  src={favoriteLOutlineSvg}
                  className="img-fluid"
                  alt="Edit"
                  width="20"
                  height="20"
                />
              ),
              tooltip: isFavorite
                ? "Unfavorite this wheel"
                : "Favorite this wheel",
              onClick: handleFavoriteWheel,
            }
          : null,
        !isHiddenWheel && {
          title: "Share",
          icon: <Share />,
          tooltip: "Share",
          onClick: () => {
            onSegmentClose();
            getLoggedInUser()?.id === wheelData?.user_profile?.user_id &&
              handleScreenshot();
            setOpenShare(true);
          },
          boolean: openShare,
        },
      ].filter(Boolean);

  const LeftContent = isHiddenWheel
    ? []
    : [
        {
          title: "Description",
          icon: <Description />,
          tooltip: "Wheel Info",
          onClick: () => {
            setShowInfo(!showInfo);
          },
          boolean: showInfo,
        },
        !isMobileLandscape
          ? {
              title: "Hotbar",
              icon: <HotbarIcon style={{ width: "30px", height: "30px" }} />,
              tooltip: "Hotbar",
              onClick: () => {
                setNewHotbarVisible(!newHotbarVisible);
              },
              boolean: newHotbarVisible,
            }
          : null,
        !isMobileLandscape && isEligible
          ? {
              title: "Business Box",
              icon: (
                <BusinessBoxIcon style={{ width: "30px", height: "30px" }} />
              ),
              tooltip: "Business Box",
              onClick: () => {
                setBusinessBoxVisible(!businessBoxVisible);
              },
              boolean: businessBoxVisible,
            }
          : null,
      ].filter(Boolean);

  function removeHtmlTags(str) {
    if (str) {
      return str?.replace(/<[^>]*>/g, "");
    }

    return "";
  }

  function isValidDescription(description) {
    if (description) {
      const cleanedDescription = removeHtmlTags(description)
        .replace(/&nbsp;/g, "")
        .trim();
      return cleanedDescription.length > 0;
    }
    return false;
  }

  const title = transformedText(wheelData?.wheel_name);
  const description = wheelData?.description
    ? removeHtmlTags(wheelData?.description)
    : "Test Description: Wheel with id " + wheelId;
  const image =
    wheelData?.wheel_center_media?.type === "image"
      ? wheelData?.wheel_center_media?.url
      : "no image";

  const onClickNext = () => {
    const segments = [...wheelSegments];
    const index = segments.findIndex((segment) => segment.selected);

    if (index !== -1) {
      segments[index].selected = false;
      const nextIndex = (index + 1) % segments.length;
      segments[nextIndex].selected = true;
    }

    setWheelSegments(segments);
  };

  const onClickPrev = () => {
    const segments = [...wheelSegments];
    const index = segments.findIndex((segment) => segment.selected);

    if (index !== -1) {
      segments[index].selected = false;
      const prevIndex = (index - 1 + segments.length) % segments.length;
      segments[prevIndex].selected = true;
    }

    setWheelSegments(segments);
  };

  const onClickLabel = (id) => {
    const segments = [...wheelSegments];
    const updatedSegments = segments.map((segment) => ({
      ...segment,
      selected: segment.settings?.id === id,
    }));
    setWheelSegments(updatedSegments);
  };

  const showClonePopup = () => {
    dispatch(
      openGeneralDialogModal({
        isOpen: true,
        title1: "You have already cloned this wheel!",
        primaryButtonTitle: "Create a New Clone",
        imageSrc: ASSETS.DialogImg,
        primaryButtonOnClick: () => {
          handleCloneAction("new");
        },
        secondaryButtonTitle: "Replace Previous Clone",
        secondaryButtonOnClick: () => {
          handleCloneAction("overwrite");
        },
      })
    );
  };

  const onFollowOrMessage = () => {
    if (!isUserLoggedIn()) {
      dispatch(
        openGeneralDialogModal({
          isOpen: true,
          title1: "Ready to connect?",
          title2: "Create an iYuga account to follow or message this user!",

          primaryButtonTitle: "Create an account",
          imageSrc: ASSETS.DialogImg,
          primaryButtonOnClick: navigateToSignup,
          secondaryButtonTitle: "Login",
          secondaryButtonOnClick: () => {
            nav("/login");
          },
        })
      );
    }
  };

  useEffect(() => {
    const handleBeforeUnload = () => {
      // Just dispatch close modal action
      // We don't need to prevent default here as we want the navigation to proceed
      dispatch(closeNonAuthenticatedModal());
      dispatch(closeGeneralDialogModal());
    };

    const handlePopState = () => {
      dispatch(closeNonAuthenticatedModal());
      dispatch(closeGeneralDialogModal());
    };

    // Add event listeners
    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handlePopState);

    // Clean up
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
    };
  }, [dispatch]);

  const handleFollow = async () => {
    if (!isUserLoggedIn()) {
      dispatch(
        openNonAuthenticatedModal({
          title: "Follow User?",
          action: "follow",
          type: "user",
          headerIcon: InfoOutlinedIcon,
          headerIconProps: {
            sx: { color: "#9B5AF8", width: "24px", height: "24px" },
          },
          referralCode: wheelData?.wheel_referrer?.referral_code,
        })
      );
      return;
    }

    const userId = wheelData?.user_profile?.user_id;
    if (!userId) return;

    try {
      setFollowLoading(true);
      const path = isFollowing
        ? API_PATH.UNFOLLOW_USER(userId)
        : API_PATH.FOLLOW_USER(userId);
      const res = await API.post(path);
      const message = res?.data?.message;
      if (message) toast.success(message);
      // toggle local state
      setIsFollowing((prev) => !prev);
      setFollowerCount((c) =>
        isFollowing ? Math.max(0, c - 1) : (c || 0) + 1
      );
    } catch (err) {
      console.error(err);
      toast.error(
        err?.response?.data?.message || "Failed to update follow status"
      );
    } finally {
      setFollowLoading(false);
    }
  };

  const handleCloneAction = (action) => {
    cloneWheel.mutate(
      { wheelId: wheelData?.id, action },
      {
        onSuccess: (res) => {
          toast.success("Wheel has been cloned.");
        },
        onError: (err) => {
          console.log(err);
          toast.error(err?.response?.data?.message || "Something went wrong");
        },
      }
    );
  };

  const handleUnlock = async (password) => {
    if (password.length === 0)
      return toast.error("Access code cannot be empty");
    unlockWheel.mutate(
      { wheelId, access_code: password, lock_type: 2 },
      {
        onSuccess: async (res) => {
          const anonymousKey = res?.data?.data?.key;
          // Pass the anonymous key from unlock response
          await getWheelData(wheelId, { anonymousKey });
          toast.success("Wheel unlocked");
        },
        onError: (err) => {
          console.log(err?.response?.data?.message);
          toast.error(err?.response?.data?.message || "Something went wrong");
        },
      }
    );
  };

  const onHandleGoBackOnPasswordModal = () => {
    const isLoggedIn = isUserLoggedIn();
    const previousPath = location.state?.from;
    const loggedInUserId = getLoggedInUser()?.id;

    if (isLoggedIn) {
      if (previousPath?.includes("/gallery/")) {
        // If coming from a gallery page, just go back
        nav(-1);
      } else {
        // If accessed directly via URL, go to user's own gallery
        nav(`/gallery/${loggedInUserId}`);
      }
    } else {
      // Non-logged in user - redirect to login
      nav("/login");
    }
    setOpenPasswordModal(false);
  };

  const renderHiddenWheelView = () => {
    return (
      <Styled.HiddenWheelContainer>
        <Styled.NoDataContainer>
          <img src={HiddenWheelIcon} alt="hidden" />

          <Styled.TextContainer>
            <TextView variant="subtitle">Oops! Nothing to see here!</TextView>
            <Button
              variant="outlined"
              style={{ width: "72px", fontSize: "12px", zIndex: 10000 }}
              onClick={() => nav(-1)}
            >
              Go Back
            </Button>
          </Styled.TextContainer>
        </Styled.NoDataContainer>
      </Styled.HiddenWheelContainer>
    );
  };

  useEffect(() => {
    if (isMobileLandscape && document.hasFocus()) {
      // enterFullscreen();
    }

    // Clean up the full-screen state when the component unmounts
    return () => {
      if (document.fullscreenElement) {
        // exitFullscreen();
      }
    };
  }, [isMobileLandscape]);

  const wheelRef = useRef(null);
  // Screenshot functionality moved to backend Lambda
  // const [screenshotImage, takeScreenshot] = useScreenshot();
  // const [isScreenshotModalOpen, setIsScreenshotModalOpen] = useState(false);

  const handleScreenshot = async () => {
    try {
      console.log("Calling backend Lambda to take wheel screenshot");
      await takeWheelScreenshot(wheelId);
      console.log("Screenshot taken successfully by backend Lambda");
      
      // Refresh wheel data to get updated preview
      await getWheelData(wheelId, {});
    } catch (error) {
      console.error("Error taking wheel screenshot:", error);
    }
  };

  useEffect(() => {
    const convertWallpaperToBase64 = async () => {
      if (bgWallpaper && bgWallpaper?.startsWith("http")) {
        try {
          console.log("curren0101011tBg", "TRY 64 bgWallpaper", bgWallpaper);
          const base64 = await fetchImageAsBase64(bgWallpaper);
          setBase64Wallpaper(base64);
        } catch (error) {
          console.error("Error converting wallpaper to base64:", error);
          setBase64Wallpaper(bgWallpaper);
          console.log("curren0101011tBg", "Catch 64 bgWallpaper");
        }
      } else {
        console.log("curren0101011tBg", "Else 64 bgWallpaper");

        setBase64Wallpaper(bgWallpaper);
      }
    };

    convertWallpaperToBase64();
  }, [bgWallpaper]);


  if (isMobilePortrait) {
    return (
      <>
        <HelmetProvider>
          <Helmet>
            <title>{title} | iYuga</title>
            <meta name="description" content={description} />
            <meta property="og:image:secure_url" content={image} />
            <meta property="og:image" content={image} />
            <meta property="og:title" content={title} />
            <meta property="og:site_name" content="iYuga" />
            <meta property="og:url" content={window.location.href} />
            <meta property="og:type" content="website" />
            <meta property="og:description" content={description} />

            {/* twitter card */}
            <meta property="twitter:card" content="summary" />
            <meta property="twitter:title" content={title} />
            <meta property="twitter:description" content={description} />
            <meta property="twitter:image" content={image} />
          </Helmet>
        </HelmetProvider>
        <MobileView
          wallpaperSettings={wallpaperSettings}
          wheelData={wheelData}
          userData={userData}
          handleSetChartData={handleSetChartData}
          selectedArc={selectedArc}
          onClose={onSegmentClose}
          wheelSegments={clonedWheelData}
          onClickNext={onClickNext}
          onClickPrev={onClickPrev}
          onClickLabel={onClickLabel}
          userProfile={wheelData?.user_profile}
          handleCloneWheel={handleCloneWheel}
          handleLikeUnlike={handleLikeUnlike}
          isLiked={isLiked}
          isHiddenWheel={isHiddenWheel}
          renderHiddenWheelView={renderHiddenWheelView}
          setInviteShareModalVisible={setInviteShareModalVisible}
          inviteShareModalVisible={inviteShareModalVisible}
          nav={nav} // Pass nav function to MobileView
          navigateToSignup={navigateToSignup}
        />

        <AccessKeyEnterModal
          // error={unlockError}
          // setError={setUnlockError}
          // loading={unlockWheelLoading}
          onSubmit={(password) => {
            handleUnlock(password);
          }}
          isOpen={openPasswordModal}
          handleClose={onHandleGoBackOnPasswordModal}
          isShowCancel={true}
        />
      </>
    );
  } else
    return (
      <>
        <AccessKeyEnterModal
          // error={unlockError}
          // setError={setUnlockError}
          // loading={unlockWheelLoading}
          onSubmit={(password) => {
            handleUnlock(password);
          }}
          handleClose={onHandleGoBackOnPasswordModal}
          isOpen={openPasswordModal}
          isShowCancel={true}
        />

        {/* <button onClick={handleScreenshot}>Take Wheel Screenshot</button> */}

        <Styled.Wrapper>
          <HelmetProvider>
            <Helmet>
              <title>{title} | iYuga</title>
              <meta name="description" content={description} />
              <meta property="og:image:secure_url" content={image} />
              <meta property="og:image" content={image} />
              <meta property="og:title" content={title} />
              <meta property="og:site_name" content="iYuga" />
              <meta property="og:url" content={window.location.href} />
              <meta property="og:type" content="website" />
              <meta property="og:description" content={description} />

              {/* twitter card */}
              <meta property="twitter:card" content="summary" />
              <meta property="twitter:title" content={title} />
              <meta property="twitter:description" content={description} />
              <meta property="twitter:image" content={image} />
            </Helmet>
          </HelmetProvider>

          {(currentBg === 2 || currentBg === 3) && base64Wallpaper !== "" && (
            <Styled.WheelWallpaperImage
              currentBg={currentBg}
              bgWallpaper={base64Wallpaper}
              wallpaperTransparency={wallpaperTransparency}
            />
          )}
          {false ? (
            <Loader />
          ) : (
            <>
              {loading && <BackdropSpinner open={loading} />}

              {isTablet && (selectedArc || segmentListOpen) ? (
                <></>
              ) : (
                <WheelHeader
                  disabled={true}
                  wheelId={wheelData?.id}
                  wheelName={wheelData?.wheel_name}
                  subtitle={wheelData?.sub_title}
                  rightContent={rightContent}
                  leftContent={LeftContent}
                  isCloned={
                    wheelData?.is_cloned || wheelData?.is_copied_from_clone
                  }
                  selectedArc={!!selectedArc || segmentListOpen}
                  handleCloneWheel={handleCloneWheel}
                  handleLikeUnlike={handleLikeUnlike}
                  handleShare={() => {
                    setOpenShare(true);
                    handleScreenshot();
                  }}
                  showBroadCastButton={false}
                  isLiked={isLiked}
                  onClickBeta={() =>
                    setInviteShareModalVisible(!inviteShareModalVisible)
                  }
                  navigateToSignup={navigateToSignup}
                  handleLogoClick={() => {
                    getLoggedInUser()
                      ? nav(`/gallery/${getLoggedInUser().id}`)
                      : nav("/login");
                  }}
                />
              )}
              {isMobileLandscape && (selectedArc || segmentListOpen) && (
                <InfoHeader
                  onClickNext={onClickNext}
                  onClickPrev={onClickPrev}
                  wheelName={wheelData?.wheel_name}
                  toggleSegmentList={() => setSegmentListOpen(!segmentListOpen)}
                  onBack={onSegmentClose}
                  selectedArc={!!selectedArc}
                />
              )}
              {isHiddenWheel ? (
                renderHiddenWheelView()
              ) : (
                <>
                  <Styled.Background
                    color={segmentBgColor}
                    currentBg={currentBg}
                    bgWallpaper={bgWallpaper}
                    wallpaperTransparency={wallpaperTransparency}
                  />
                  <Styled.Grid
                    isMobile={isMobileLandscape}
                    showInfo={
                      showInfo || newHotbarVisible || businessBoxVisible
                    }
                    selectedArc={!!selectedArc}
                  >
                    <Styled.LeftColumn>
                      {showInfo &&
                        !(
                          (segmentListOpen || selectedArc) &&
                          isMobileLandscape
                        ) && (
                          <>
                            <AuthorInfo
                              data={profile}
                              onFollowOrMessage={onFollowOrMessage}
                              handleFollow={handleFollow}
                              followLoading={followLoading}
                              isFollowing={isFollowing}
                              followerCount={followerCount}
                              isUserProfile={isMyWheel}
                              onCountsRefresh={() => refetchProfile()}
                            />
                            {isValidDescription(wheelData?.description) && (
                              <WheelInfo data={wheelData} />
                            )}
                          </>
                        )}
                    </Styled.LeftColumn>
                    <Styled.CenterColumn
                      showInfo={
                        showInfo || newHotbarVisible || businessBoxVisible
                      }
                      selectedArc={!!selectedArc}
                      style={{
                        alignItems: segmentListOpen ? "flex-start" : "center",
                      }}
                    >
                      <Styled.WheelWrapper>
                        {segmentListOpen && (
                          <SegmentsList
                            wheelSegments={clonedWheelData}
                            onClickLabel={onClickLabel}
                            selectedArc={!!selectedArc}
                            onClose={() => setSegmentListOpen(false)}
                          />
                        )}
                        {!(segmentListOpen && isMobileLandscape) && (
                          <>
                            <WheelComponent
                              width={isMobileLandscape ? "40vw" : "32vw"}
                              height={isMobileLandscape ? "40vw" : "32vw"}
                              chartData={clonedWheelData}
                              setChartData={handleSetChartData}
                              showLabels={
                                (isMobileLandscape && !selectedArc) ||
                                showLabels
                              }
                              config={{
                                isNotDraggable: true,
                                segmentHighlighting: false,
                              }}
                              userData={userData}
                            />
                            {!isMobileLandscape && (
                              <Styled.LabelWrapper>
                                <Styled.LabelText>Show Label</Styled.LabelText>
                                <CustomSwitch
                                  defaultChecked={true}
                                  value={showLabels}
                                  onChange={handleSwitch}
                                />
                              </Styled.LabelWrapper>
                            )}
                          </>
                        )}
                      </Styled.WheelWrapper>

                      {/* <WaitlistFormModal
                        open={InviteShareModalVisible}
                        onClose={() => setInviteShareModalVisible(false)}
                        wheelData={wheelData}
                      /> */}

                      {/* <ShareInviteModal isVisible={true} onClose={() => { }} /> */}
                    </Styled.CenterColumn>
                    {isMobileLandscape && (
                      <>
                        {!(selectedArc || segmentListOpen) && (
                          <Styled.IconView
                            onClick={() => setSegmentListOpen(!segmentListOpen)}
                          >
                            <List />
                          </Styled.IconView>
                        )}
                      </>
                    )}
                    <Styled.RightColumn>
                      {selectedArc && (
                        <Editor enabled={false}>
                          <SegmentView
                            selectedArc={selectedArc}
                            onClose={onSegmentClose}
                          />
                        </Editor>
                      )}
                    </Styled.RightColumn>
                  </Styled.Grid>
                </>
              )}

              <GeneralDialog />

              {/* <WaitlistFormModal
                open={InviteShareModalVisible}
                onClose={() => setInviteShareModalVisible(false)}
                wheelData={wheelData}
                onSuccess={() => setShowToast(true)}
              /> */}

              <ShareInviteModal
                isVisible={inviteShareModalVisible}
                onClose={() => setInviteShareModalVisible(false)}
              />
              {showToast && (
                <ToastMessage
                  message={`BETA waitlist account is created!!`}
                  type={TOAST_TYPE.SUCCESS}
                />
              )}
              {openShare && (
                <ShareModal
                  userData={userData}
                  chartData={clonedWheelData}
                  wheel={wheelData}
                  handleClose={() => setOpenShare(false)}
                  color={segmentBgColor}
                  currentBg={currentBg}
                  bgWallpaper={bgWallpaper}
                  wallpaperTransparency={wallpaperTransparency}
                />
              )}
            </>
          )}

          <SocialFoxFeedbackForm
            open={openFeedbackModal}
            onClose={() => {
              setOpenFeedbackModal(false);
            }}
          />
          <NewHotbar
            isOpen={newHotbarVisible}
            onClose={() => setNewHotbarVisible(false)}
            onSegmentOpen={onSegmentOpen}
          />
          <BusinessBoxBuilder
            isVisible={businessBoxVisible}
            isViewWheel
            onClose={() => setBusinessBoxVisible(false)}
          />
          {selectedType === "images" && isPreviewOpen && (
            <PreviewCarousel
              onViewInWheel={onSegmentOpen}
              imageArray={
                segments?.filter((e) => e?.title === selectedSegment)[0]?.items
                  ?.images
              }
              selectedImage={selectedItem}
            />
          )}

          <BroadCastModal
            isOpen={showCloneUpdateModal}
            handleClose={() => setshowCloneUpdateModal(false)}
            modalText="Since your last visit, this synced clone has been updated by it’s creator!"
            cancelButtonVisible={false}
            buttonText="Confirm"
            onSubmit={() => setshowCloneUpdateModal(false)}
          />

          <BroadCastModal
            isOpen={showIsLiveToStaticModal}
            handleClose={() => setshowIsLiveToStaticModal(false)}
            prefixIcon={ASSETS.BroadCastUpdateYellowIcon}
            title={"Not a live wheel anymore!"}
            modalText="This Clone's Live Link to the original Wheel has been broken. This is now a 'Static' Clone, which can be edited freely. Have fun!"
            cancelButtonVisible={false}
            buttonText="Okay!"
            onSubmit={() => setshowIsLiveToStaticModal(false)}
          />
        </Styled.Wrapper>

        {/* <WheelLimitPopup 
          open={openPopup} 
          handleClose={() => setOpenPopup(false)}
          type="clone" 
        /> */}

        {/* Screenshot functionality moved to backend Lambda */}
        {/* <ScreenshotModal
          // isOpen={true}
          isOpen={isScreenshotModalOpen}
          onClose={() => setIsScreenshotModalOpen(false)}
          segmentBgColor={segmentBgColor}
          currentBg={currentBg}
          base64Wallpaper={base64Wallpaper}
          wallpaperTransparency={wallpaperTransparency}
          chartData={clonedWheelData}
          userData={userData}
        /> */}

        <NonAuthenticatedModal />
      </>
    );
}
